export default "__VITE_ASSET__f0b2a995__"